import React from 'react';
import LoginForm from '../../login-form';

function LoginPage() {
    return(
        <div>
            <LoginForm />
        </div>
    )
}

export default LoginPage;